
import { defineComponent, ref } from "vue";

import UserStatus from "@/utils/userStatus";
import axios from "axios";
import apis, { IndexRecord, PaginatedModel } from "@/apis";
import dayjs from "dayjs";
import xlsx, { IContent, IJsonSheet } from "json-as-xlsx";
import CategoryInfo from "@/utils/categoryInfo";
import { AlertQueue } from "@/utils/alertQueue";
import { PseudoCreateExtension, pseudoQuarantineMap } from "@/utils/pseudoTypes";

export default defineComponent({
  setup() {
    const apiGetIndex = (page?: number) => {
      if (!page || page < 1) page = 1;
      return axios({
        url: apis.index.url,
        method: apis.index.method,
        params: { page: page },
      });
    };

    const categoryInfo = CategoryInfo.info();

    const exportExcel = async () => {
      if (!categoryInfo.value.isInited) {
        AlertQueue.warn("正在获取分组信息，请稍后再试或刷新页面。");
        return;
      }

      const indexRecords = ref([] as Array<IndexRecord>);

      let page = 1;
      const d = await apiGetIndex(page);
      if (d.data.totalPages && d.data.totalPages > 0) {
        const paginated = d.data as PaginatedModel<IndexRecord>;

        for (let i = 0; i < paginated.records.length; ++i) {
          indexRecords.value[(page - 1) * apis.index.pageSize + i] = paginated.records[i];
        }

        let dtLiteral = Date.now();
        if (d.data.totalPages > 1) {
          const queries = [];
          for (let i = 2; i <= d.data.totalPages; ++i) {
            queries.push(apiGetIndex(i));
          }
          const results = await Promise.all(queries);
          dtLiteral = Date.now();

          for (let j = 0; j < results.length; ++j) {
            const thisPage = results[j].data as PaginatedModel<IndexRecord>;

            for (let i = 0; i < thisPage.records.length; ++i) {
              indexRecords.value[(j + 1) * apis.index.pageSize + i] = thisPage.records[i];
            }
          }
        }

        const xData = [
          {
            sheet: `疫情求助平台导出数据`,
            columns: [
              { label: 'id', value: 'id' },
              { label: '区域', value: row => {
                let regionLiteral = "";
                if (row.groupId) {
                  const groupId = row.groupId as number;
                  const group = categoryInfo.value.groups.find(e => e.id === groupId);
                  if (group) regionLiteral = group.name;
                }

                return regionLiteral;
              }},
              { label: '隔离类型', value: row => {
                let school = "";
                if (row.school) {
                  try {
                    const literal: PseudoCreateExtension = JSON.parse(row.school as string);
                    if (literal.qt) {
                      const targetType = pseudoQuarantineMap.find(e => e.id === literal.qt);
                      if (targetType) {
                        school = targetType.name;
                      }
                    }
                  }
                  catch {
                    school = "";
                  }
                }
                return school;
              } },
              { label: '公开', value: row => ( row.isValid ? "是" : "" ) },
              { label: '发布时间', value: 'timeCreate' },
              { label: '称呼', value: 'name' },
              { label: '联系方式', value: 'mobile' },
              { label: '回复', value: row => {
                const childs = (row.childComments as unknown as Array<IndexRecord>).map(e => new Object({
                  info: e.isModerator ? "平台回复" : "",
                  content: e.content
                }));
                if (childs.length > 0)
                  return JSON.stringify(childs)
                else return "";
              }},
              { label: '内容', value: 'content' },
            ],
            content: indexRecords.value as unknown as Array<IContent>,
          },
        ] as Array<IJsonSheet>;
        
        xlsx(xData, {
          fileName: `records-export-${dayjs(dtLiteral).format("YYMMDD-HHmmss-SSS")}`,
          extraLength: 3,
          writeOptions: {},
        });
      }
    }

    return {
      userStatus: UserStatus.status,
      exportExcel,
    };
  },
});
